import { createSlice } from '@reduxjs/toolkit';
import { PickingGrouping, } from '../models';
const initialState = {
    ownerLocation: 'task',
    pickingTasksArticleSearchTerm: '',
    grouping: PickingGrouping.None,
    pickingTasksDateRangeFilter: {
        // Should always be `null`, otherwise it fires additional request with this initial values right before the
        // necessary request with values, gotten from local storage.
        dateFrom: null,
        dateTo: null,
    },
    isPickedActive: false,
    pickedTaskCount: undefined,
    notPickedTaskCount: undefined,
    verificationItemCount: undefined,
    taskDetails: undefined,
    pickupPickingItemDialog: {
        open: false,
        data: undefined,
        availableQuantity: 0,
        isError: false,
        error: undefined,
    },
    blockPickingItemDialog: {
        open: false,
        data: undefined,
    },
    revokePickingItemDialog: {
        open: false,
        data: undefined,
        additionalData: undefined,
        markedItemIds: [],
    },
};
const slice = createSlice({
    name: 'picking',
    initialState,
    reducers: {
        setOwnerLocation: (state, action) => {
            state.ownerLocation = action.payload;
        },
        setPickingTasksArticleSearchTerm: (state, action) => {
            state.pickingTasksArticleSearchTerm = action.payload;
        },
        setGrouping: (state, action) => {
            state.grouping = action.payload;
        },
        setPickingTasksDateRangeFilter: (state, action) => {
            state.pickingTasksDateRangeFilter = action.payload;
        },
        setIsPickedActive: (state, action) => {
            state.isPickedActive = action.payload;
        },
        setPickedTaskCount: (state, action) => {
            state.pickedTaskCount = action.payload;
        },
        setNotPickedTaskCount: (state, action) => {
            state.notPickedTaskCount = action.payload;
        },
        updatePickingTasksCounters: (state, action) => {
            if (state.notPickedTaskCount === undefined || state.pickedTaskCount === undefined)
                return;
            if (action.payload === 'movedToPicked') {
                state.notPickedTaskCount = state.notPickedTaskCount - 1;
                state.pickedTaskCount = state.pickedTaskCount + 1;
            }
            else {
                state.notPickedTaskCount = state.notPickedTaskCount + 1;
                state.pickedTaskCount = state.pickedTaskCount - 1;
            }
        },
        setVerificationItemCount: (state, action) => {
            state.verificationItemCount = action.payload;
        },
        setTaskDetails: (state, action) => {
            state.taskDetails = action.payload;
        },
        clearTaskDetails: (state) => {
            state.taskDetails = initialState.taskDetails;
        },
        openPickupPickingItemDialog: (state, action) => {
            state.pickupPickingItemDialog = {
                ...state.pickupPickingItemDialog,
                open: true,
                data: action.payload.item,
                availableQuantity: action.payload.availableQuantity,
            };
        },
        closePickupPickingItemDialog: (state) => {
            state.pickupPickingItemDialog = initialState.pickupPickingItemDialog;
        },
        openBlockPickingItemDialog: (state, action) => {
            const { id, article, brand, name, quantity, pickedQuantity, blockedQuantity } = action.payload;
            state.blockPickingItemDialog.open = true;
            state.blockPickingItemDialog.data = {
                id,
                article,
                brand,
                name,
                availableQuantity: quantity - pickedQuantity - blockedQuantity,
            };
        },
        closeBlockPickingItemDialog: (state) => {
            state.blockPickingItemDialog = initialState.blockPickingItemDialog;
        },
        openRevokePickingItemDialog: (state, action) => {
            state.revokePickingItemDialog.open = true;
            state.revokePickingItemDialog.data = {
                isUnblocking: action.payload.isUnblocking,
                pickingItemId: action.payload.pickingItemId,
            };
            state.revokePickingItemDialog.additionalData = {
                pickingItemBlockedQuantity: action.payload.blockedQuantity,
            };
        },
        markItem: (state, action) => {
            const markedIds = state.revokePickingItemDialog.markedItemIds;
            const id = action.payload.itemId;
            state.revokePickingItemDialog.markedItemIds = markedIds.includes(id)
                ? markedIds.filter((markedId) => markedId !== id)
                : [...markedIds, id];
        },
        markAll: (state, action) => {
            const markedIds = state.revokePickingItemDialog.markedItemIds;
            const revokableItems = [...action.payload.items];
            state.revokePickingItemDialog.markedItemIds =
                markedIds.length === revokableItems.length ? [] : revokableItems.map((item) => item.id);
        },
        closeRevokePickingItemDialog: (state) => {
            state.revokePickingItemDialog = initialState.revokePickingItemDialog;
        },
    },
});
export const { actions: pickingActions, reducer: pickingStateReducer } = slice;
